import React from "react";
import PropTypes from "prop-types";
import { get } from "utils/api";
import { useFetch } from "hooks";
import { Waiting, ListItem } from "components/ui";
import moment from "moment";
import { path } from "ramda";
import HasRolePermission from "components/shared/has-role-permission";

// Normalized Paubox event types -> display labels
const EVENT_LABELS = {
  delivered: "Delivered",
  opened: "Opened",
  temporary_failure: "Soft Bounce",
  permanent_failure: "Hard Bounce"
};

const formatEventType = t => EVENT_LABELS[t] || t;
const formatTime = t => (t ? moment(t).format("MMM DD, YYYY -  hh:mm A") : "");

const containerStyle = { padding: "20px 24px" };
const sectionHeadingStyle = { margin: "20px 0 8px", fontSize: 13, color: "#666" };

// Email engagement details — content for a simple modal. Admin-only (gated here and at the trigger).
const EmailRecordProfile = ({ contactGuid }) => {
  const { response: detail, isFetching, error, fetchData } = useFetch({
    apiFn: guid => get(`patients/contact-records/${guid}/email-engagement`),
    transformError: path(["response", "body", "message"])
  });

  React.useEffect(() => {
    if (contactGuid) fetchData(contactGuid);
  }, [contactGuid]);

  return (
    <HasRolePermission
      allowedRoles={["Administrator"]}
      renderElse={<div style={containerStyle}>Not authorized.</div>}
    >
      <div className="email-engagement-modal" style={containerStyle}>
        {error && !isFetching && <div className="fetch-error">{error}</div>}
        {isFetching && <Waiting size="40px" />}

        {detail && !isFetching && (
          <React.Fragment>
            <ListItem label="To" value={detail.recipient} underline />
            <ListItem label="Category" value={detail.category} underline />
            <ListItem label="Sent" value={formatTime(detail.sentAt)} underline />
            <ListItem label="Status" value={detail.status} underline />

            <div style={sectionHeadingStyle}>Timeline</div>
            {detail.events && detail.events.length ? (
              detail.events.map((e, i) => (
                <ListItem
                  key={`${e.eventType}-${i}`}
                  label={formatEventType(e.eventType)}
                  value={formatTime(e.occurredAt)}
                  underline={i < detail.events.length - 1}
                />
              ))
            ) : (
              <div style={{ color: "#888" }}>No engagement events yet.</div>
            )}
          </React.Fragment>
        )}
      </div>
    </HasRolePermission>
  );
};

EmailRecordProfile.propTypes = {
  contactGuid: PropTypes.string
};

export default EmailRecordProfile;
